'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineOverlay = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAccessibilityManageFocus = require('@bibliocommons/base-accessibility-manage-focus');

var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);

require('../styles/InlineOverlay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineOverlay = exports.InlineOverlay = function (_BcReactComponent) {
  _inherits(InlineOverlay, _BcReactComponent);

  function InlineOverlay() {
    _classCallCheck(this, InlineOverlay);

    return _possibleConstructorReturn(this, (InlineOverlay.__proto__ || Object.getPrototypeOf(InlineOverlay)).apply(this, arguments));
  }

  _createClass(InlineOverlay, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        handleClose: this.props.handleClose
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.captureFocus(this._element, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.restoreFocus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['className', 'children']);

      delete restProps.handleClose;

      return _react2.default.createElement(
        'div',
        _extends({ className: (0, _classnames2.default)('cp-inline-overlay', className), ref: function ref(el) {
            _this2._element = el;
          } }, restProps),
        children
      );
    }
  }]);

  return InlineOverlay;
}(_baseBcReactComponent2.default);

InlineOverlay.propTypes = {
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired,
  className: _react.PropTypes.string,
  handleClose: _react.PropTypes.func.isRequired
};

InlineOverlay.childContextTypes = {
  handleClose: _react.PropTypes.func.isRequired
};

InlineOverlay.displayName = 'InlineOverlay';

exports.default = (0, _baseAccessibilityManageFocus2.default)(InlineOverlay);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-overlay/lib/components/inline-overlay/components/InlineOverlay.component.js
// module id = 1324
// module chunks = 1